<script lang="ts" setup>
import { GpBtn } from '@gportal/uikit';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    label?: string;
    icon?: string | string[];
    disabled?: boolean;
    btnType?:
      | 'primary'
      | 'flat'
      | 'danger'
      | 'warning'
      | 'success'
      | 'info'
      | 'cancel'
      | 'transparent';
  }>(),
  {
    label: '',
    icon: undefined,
    disabled: false,
    btnType: 'primary',
  },
);

const emit = defineEmits<{
  click: [];
}>();

const btnIcon = computed(() => {
  if (props.icon) {
    return typeof props.icon === 'string' ? ['fas', props.icon] : props.icon;
  }

  return undefined;
});
</script>

<template>
  <GpBtn
    class="tw-w-full xl:tw-w-auto xl:tw-min-w-40"
    :btn-type="btnType"
    size="sm"
    :disabled="disabled"
    :icon="btnIcon"
    :label="label"
    v-bind="$attrs"
    @click="emit('click')"
  >
    <slot></slot>
  </GpBtn>
</template>
